function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  fill: "#528BFD",
  cx: 14,
  cy: 14,
  r: 14
}), React.createElement("path", {
  d: "M13.376 14.687c-.392.3-.948.316-1.36.04l-1.303-.876a.925.925 0 00-1.14.09.742.742 0 00-.05 1.04l2.113 2.398c.037.043.078.084.12.122.6.537 1.548.514 2.117-.052l5.36-5.32a.695.695 0 00-.014-1.01.868.868 0 00-1.11-.055l-4.733 3.623z",
  fill: "#F7F8FB"
}));

var SvgTickBig = function SvgTickBig(props) {
  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28"
  }, props), _ref);
};

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='28px' height='28px' viewBox='0 0 28 28' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg transform='translate(-28.000000, -941.000000)'%3E %3Cg transform='translate(28.000000, 895.000000)'%3E %3Cg transform='translate(0.000000, 46.000000)'%3E %3Cg%3E %3Ccircle fill='%23528BFD' cx='14' cy='14' r='14'%3E%3C/circle%3E %3Cpath d='M13.3760703,14.6868374 C12.9839858,14.986961 12.4275313,15.0033924 12.0162816,14.7269903 L10.7126537,13.8508181 C10.3608796,13.6143896 9.87934395,13.652128 9.57383337,13.9400685 C9.27391261,14.2227406 9.25178419,14.6741893 9.52277533,14.9817193 L11.6355562,17.379375 C11.6732629,17.4221658 11.7136213,17.4628178 11.7564202,17.501118 C12.3560194,18.0376926 13.3036127,18.0145554 13.8729291,17.4494395 L19.2333201,12.1285991 C19.520127,11.8439084 19.5139674,11.3956619 19.2194339,11.1180672 C18.9186563,10.8345875 18.439202,10.8112308 18.109017,11.063973 L13.3760703,14.6868374 Z' fill='%23F7F8FB'%3E%3C/path%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgTickBig as ReactComponent };